var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout md-alignment-center-center"},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"scrolling":"no","src":_vm.dashboardUrl,"frameborder":"0","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }